// extracted by mini-css-extract-plugin
export default {"list":"RaffleCardList_list__M4BYp","fetching":"RaffleCardList_fetching__gRsvd","placeholder":"RaffleCardList_placeholder__SFtDt"};